import React from 'react';
import { Paper, Typography, Divider, Grid, Box } from '@mui/material';

/**
 * Mirrors the "CASH SUMMARY" block on the printed Performance Analysis form.
 * Field order matches the PDF top-to-bottom:
 * Total LSF, Total Advances Paid, Advance Interest Paid, Loan Repaid,
 * Others, Fines & Penalties, Total Collection, Cash from Office,
 * Total Cash at Hand, Less Advances Given, Less Loans Given,
 * Funds in Office, Net Cash Remitted, Paid via M-Pesa.
 */
const Row = ({ label, value, bold, color }) => (
  <>
    <Grid item xs={7} sx={{ py: 0.6 }}>
      <Typography variant="body1" sx={bold ? { fontWeight: 'bold' } : undefined}>
        {label}
      </Typography>
    </Grid>
    <Grid item xs={5} sx={{ py: 0.6 }}>
      <Typography
        variant="body1"
        align="right"
        sx={{ ...(bold ? { fontWeight: 'bold' } : {}), ...(color ? { color } : {}) }}
      >
        {value}
      </Typography>
    </Grid>
  </>
);

const CashSummary = ({ cashSummary, formatCurrency }) => {
  const c = cashSummary || {};

  return (
    <Paper sx={{ p: 2, height: '100%' }} data-testid="cash-summary">
      <Typography variant="h6" gutterBottom color="primary">
        CASH SUMMARY
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <Box sx={{ mb: 2 }}>
        <Grid container spacing={1.2}>
          <Row label="Total LSF" value={formatCurrency(c.totalLSF)} />
          <Row label="Total Advances Paid" value={formatCurrency(c.totalAdvancesPaid)} />
          <Row label="Advance Interest Paid" value={formatCurrency(c.advanceInterestPaid)} />
          <Row label="Loan Repaid" value={formatCurrency(c.loanRepaid)} />
          <Row label="Others" value={formatCurrency(c.others)} />
          <Row label="Fines & Penalties" value={formatCurrency(c.finesPenalties)} />
          <Row label="Total Collection" value={formatCurrency(c.totalCollection)} bold />
          <Row label="Cash from Office" value={formatCurrency(c.cashFromOffice)} />
          <Row label="Total Cash at Hand" value={formatCurrency(c.totalCashAtHand)} bold />
          <Row label="Less Advances Given" value={formatCurrency(c.lessAdvancesGiven)} />
          <Row label="Less Loans Given" value={formatCurrency(c.lessLoansGiven)} />
          <Row label="Funds in the Office" value={formatCurrency(c.fundsInOffice)} />
          <Row
            label="Net Cash Remitted"
            value={formatCurrency(c.netCashRemitted)}
            bold
            color="success.main"
          />
          <Row label="Paid via M-Pesa" value={formatCurrency(c.paidViaMpesa)} />
        </Grid>
      </Box>
    </Paper>
  );
};

export default CashSummary;